import axios, { AxiosRequestConfig } from 'axios';
import Event from './easyfy.events/easyfy.eventhandler';

namespace Easyfy.Shared.Scripts {
  export interface IExtraHeaders {
    key: string;
    value: string;
  }

  export const get = async (url: string, config?: AxiosRequestConfig): Promise<any> => {
    axios.defaults.headers.common["IsAxiosRequest"] = true;
    axios.defaults.headers.common["OriginalUrl"] = window.location.href;

    url = generateFullPathWithPrefix(url);

    var response = await axios.get(url, config);
    Event.EasyfyEventHandler.RegisterResponseData(response);
    return response;
  };

  export const post = async (url: string, data: any, token?: string, config?: AxiosRequestConfig) => {
    if (token) {
      axios.defaults.headers.common["RequestVerificationToken"] = token;
    }
    axios.defaults.headers.common["IsAxiosRequest"] = true;
    axios.defaults.headers.common["OriginalUrl"] = window.location.href;

    url = generateFullPathWithPrefix(url);

    var response = await axios.post(url, data, config);
    Event.EasyfyEventHandler.RegisterResponseData(response);
    return response;
  };

  export const patch = async (url: string, data: any, token?: string, config?: AxiosRequestConfig) => {
    if (token) {
      axios.defaults.headers.common["RequestVerificationToken"] = token;
    }
    axios.defaults.headers.common["IsAxiosRequest"] = true;
    axios.defaults.headers.common["OriginalUrl"] = window.location.href;

    url = generateFullPathWithPrefix(url);

    var response = await axios.patch(url, data, config);
    Event.EasyfyEventHandler.RegisterResponseData(response);
    return response;

  };

  export const axiosDelete = async (url: string, token?: string, config?: AxiosRequestConfig) => {
    if (token) {
      axios.defaults.headers.common["RequestVerificationToken"] = token;
    }
    axios.defaults.headers.common["IsAxiosRequest"] = true;
    axios.defaults.headers.common["OriginalUrl"] = window.location.href;

    url = generateFullPathWithPrefix(url);

    var response = await axios.delete(url, config);
    Event.EasyfyEventHandler.RegisterResponseData(response);
    return response;

  };

  function generateFullPathWithPrefix(url: string): string {
    // Retrieve the data-prefix-path attribute from the document
    let prefixPath = document.documentElement?.getAttribute("data-prefix-path") || "";

    // Normalize the prefixPath: ensure it starts with a single slash and has no trailing slash
    prefixPath = prefixPath.trim();
    if (prefixPath && !prefixPath.startsWith("/")) {
      prefixPath = "/" + prefixPath;
    }
    if (prefixPath.endsWith("/")) {
      prefixPath = prefixPath.slice(0, -1);
    }

    // Normalize the url: ensure it starts with a single slash
    url = url.trim();
    if (!url.startsWith("/")) {
      url = "/" + url;
    }

    // If prefixPath is defined and the url doesn't already start with it, prepend the prefix
    if (prefixPath && !url.startsWith(prefixPath + "/") && url !== prefixPath) {
      return prefixPath + url;
    }

    // Return the original url if no prefix is needed
    return url;
  }

}

export default Easyfy.Shared.Scripts;